import config from '../config';

/** WhatsApp / Facebook için mutlak URL; önce tarayıcı kökü, yoksa kanonik prod kökü */
export function getShareOrigin() {
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }
  return config.publicSiteOrigin || '';
}

/**
 * OG görseli vb.: göreli veya tam URL → tam URL
 * @param {string} [pathOrUrl] API’den gelen primaryImage veya `/images/...`
 */
export function toAbsoluteShareUrl(pathOrUrl, origin = null) {
  const base = origin ?? getShareOrigin();
  const fallbackPath = config.defaultOgImagePath || '/images/mutfak-logo6.png';
  const raw =
    pathOrUrl != null && String(pathOrUrl).trim() !== ''
      ? String(pathOrUrl).trim()
      : fallbackPath;
  if (raw.startsWith('https://')) {
    return raw;
  }
  if (raw.startsWith('http://')) {
    return raw;
  }
  /* API bazen //cdn.example.com/... döner */
  if (raw.startsWith('//')) {
    return `https:${raw}`;
  }
  const path = raw.startsWith('/') ? raw : `/${raw}`;
  if (!base) return path;
  return `${base}${path}`;
}
